<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">ویرایش سفارش</h5>
        <div style="flex: 1"></div>
        <Back url="/admin/shop/orders" />
      </div>
      <div class="card-body">
        <form @submit.prevent="submit">
          <b-form-group class="col-md-6" label="زمان ثبت">
            <date-picker type="datetime" v-model="created_at" :format="'YYYY-MM-DD HH:mm'"
              :display-format="'jYYYY-jMM-jDD HH:mm'" />
          </b-form-group>
          <b-form-group label="مشتری">
            <div class="d-flex col-md-6 mb-3" v-if="item && item.customer" style="gap: 0.5rem">
              <b-form-input v-model="item.customer.mobile" type="text" readonly autofocus />
            </div>
          </b-form-group>
          <b-form-group class="col-6" label="انتخاب محصول">
            <div class="d-flex" style="gap: 0.5rem">
              <b-form-input autocomplete="off" ref="productSku" v-model="productSku" :disabled="disabled"
                @keypress.prevent.enter="requestProduct" type="text" />
              <div class="d-flex mr-3" style="gap: 0.6rem">
                <label for="refund_checkbox">مرجوعی</label>
                <b-form-checkbox id="refund_checkbox" type="checkbox" :disabled="disabled" v-model="refund" />
              </div>
            </div>
          </b-form-group>
          <b-form-group class="col-8" label="جستجوی محصول">
            <ProductSearch ref="productSearch" :selectable="true" class="row" :store="admin.store_id"
              :show-label="false" @selectVariety="selectVariety" />
          </b-form-group>
          <div v-if="item && item.mini_order_items && item.mini_order_items.length">
            <div v-if="sellItems.length">
              <h4 class="table-title">فروش</h4>
              <b-table class="mt-3 admin-order" hover bordered responsive :items="sellItems" :fields="fields">
                <template v-slot:cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template v-slot:cell(barcode)="data">
                  <span style="width: 300px">
                    <span style="line-height: 2">{{ data.item.variety ? data.item.variety.barcode : data.item.barcode
                      }}</span>
                  </span>
                </template>
                <template v-slot:cell(title)="data">
                  <span style="width: 300px">
                    <span style="line-height: 2">{{ data.item.product.title }}</span>
                  </span>
                </template>
                <template v-slot:cell(amount)="data">
                 <span>{{ data.item.real_amount | price }}</span>
                </template>
                <template v-slot:cell(discount_amount)="data">
                  <span v-if="data.item.final_price && data.item.final_price.discount_price > 0">{{
                    data.item.final_price.discount_price | price
                  }}</span>
                  <b-form-input v-else style="width: 80px" class="m-auto"
                    :value="data.item.discount_amount | priceinput" @input="
                      (value) => {
                        data.item.discount_amount =
                          value !== '' ? +value.replace(/\D/g, '') : '';
                      }
                    ">
                  </b-form-input>
                </template>
                <template v-slot:cell(quantity)="data">
                  <button type="button" class="border border-radius7 px-1 bg-none" @click="decrement(data.item)"
                    :disabled="data.item.quantity == 1 || disabled ? true : false">
                    <DashSvg />
                  </button>
                  <span class="px-2">{{ data.item.quantity }}</span>
                  <button type="button" class="border border-radius7 px-1 bg-none" @click="increment(data.item)"
                    :disabled="disabled">
                    <PlusSvg />
                  </button>
                </template>
                <template v-slot:cell(total_price)="data">
                  <span> {{ (data.item.price
                    ? data.item.price
                    : data.item.real_amount && data.item.real_amount > 0
                      ? data.item.real_amount
                      : data.item.amount) * data.item.quantity -
                    (data.item.final_price && data.item.final_price.discount_price > 0 ?
                      data.item.final_price.discount_price
                      * data.item.quantity : data.item.discount_amount * data.item.quantity) | price }}</span>
                </template>
                <template v-slot:cell(seller_id)="data">
                  <b-button @click="sellerModalHandler(data.item.id)">
                    <span>
                      {{
                        seller_ids[data.item.id]
                          ? seller_ids[data.item.id].label
                          : sellers && sellers.find(seller => seller.id === data.item.seller_id) ?
                            sellers && sellers.find(seller => seller.id === data.item.seller_id).label : ""
                      }}
                    </span>
                    <i class="fa fa-angle-down"></i>
                  </b-button>
                </template>
                <template v-slot:cell(more)="data">
                  <button type="button" v-show="hasPermission('delete_mini_order')" class="action-btns1 pt-1 px-1"
                    @click="deleteItem(data.index, data.item)">
                    <i class="feather feather-trash-2 text-danger"></i>
                  </button>
                </template>
              </b-table>
            </div>
            <div v-if="refundItems.length">
              <h4 class="table-title">مرجوع</h4>
              <b-table class="mt-3 admin-order" hover bordered responsive :items="refundItems" :fields="fields">
                <template v-slot:cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template v-slot:cell(barcode)="data">
                  <span style="width: 300px">
                    <span style="line-height: 2">{{ data.item.variety ? data.item.variety.barcode : data.item.barcode
                      }}</span>
                  </span>
                </template>
                <template v-slot:cell(title)="data">
                  <span style="width: 300px">
                    <span style="line-height: 2">{{ data.item.product.title }}</span>
                  </span>
                </template>
                <template v-slot:cell(amount)="data">
                  {{ getAmount(data.item) | price }}
                </template>
                <template v-slot:cell(discount_amount)="data">
                  <span v-if="data.item.final_price && data.item.final_price.discount_price > 0">{{
                    data.item.final_price.discount_price | price
                  }}</span>
                  <b-form-input v-else style="width: 80px" class="m-auto"
                    :value="data.item.discount_amount | priceinput" @input="
                      (value) => {
                        data.item.discount_amount =
                          value !== '' ? +value.replace(/\D/g, '') : '';
                      }
                    ">
                  </b-form-input>
                </template>
                <template v-slot:cell(quantity)="data">
                  <button type="button" class="border border-radius7 px-1 bg-none" @click="decrement(data.item)"
                    :disabled="data.item.quantity == 1 || disabled ? true : false">
                    <DashSvg />
                  </button>
                  <span class="px-2">{{ data.item.quantity }}</span>
                  <button type="button" class="border border-radius7 px-1 bg-none" @click="increment(data.item)"
                    :disabled="disabled">
                    <PlusSvg />
                  </button>
                </template>
                <template v-slot:cell(total_price)="data">
                  <span>
                    {{ (data.item.real_amount && data.item.real_amount > 0 
                      ? data.item.real_amount * data.item.quantity
                      : data.item.amount * data.item.quantity) -
                      (data.item.final_price && data.item.final_price.discount_price > 0 ?
                        data.item.final_price.discount_price
                        : data.item.discount_amount * data.item.quantity) | price }}</span>
                </template>
                <template v-slot:cell(seller_id)="data">
                  <b-button @click="sellerModalHandler(data.item.id)">
                    <span>
                      {{
                        seller_ids[data.item.id]
                          ? seller_ids[data.item.id].label
                          : sellers && sellers.find(seller => seller.id === data.item.seller_id) ?
                            sellers && sellers.find(seller => seller.id === data.item.seller_id).label : ""
                      }}
                    </span>
                    <i class="fa fa-angle-down"></i>
                  </b-button>
                </template>
                <template v-slot:cell(more)="data">
                  <button type="button" v-show="hasPermission('delete_mini_order')" class="action-btns1 pt-1 px-1"
                    @click="deleteItem(data.index, data.item)">
                    <i class="feather feather-trash-2 text-danger"></i>
                  </button>
                </template>
              </b-table>
            </div>
          </div>
          <template>
            <div class="mt-5 col-md-5 mx-auto card justify-content-center little py-5 d-flex" v-if="item && item.mini_order_items">
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> مجموع قیمت کالا ها : </span>
                <span class="px-3 py-2"> {{ total | price }} تومان </span>
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">
                  جمع تخفیفات (تومان):
                </span>
                <span class="px-3 py-2" v-if="item">
                  {{sellItems.reduce((total, variety) => total + (variety.final_price &&
                    variety.final_price.discount_price > 0
                    ? variety.final_price.discount_price * variety.quantity : variety.discount_amount * variety.quantity),
                    0)
                    +
                    refundItems.reduce((total, variety) => total + (variety.final_price &&
                      variety.final_price.discount_price > 0
                      ? variety.final_price.discount_price * variety.quantity : variety.discount_amount * variety.quantity),
                      0)
                  | price }} تومان
                </span>
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> فاکتور باز : </span>
                <div class="px-3 py-2">
                  <input type="checkbox" v-model="item.is_open">
                </div>
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">
                  مبلغ کارت به کارت (تومان):
                </span>
                <b-form-input style="width: 130px" :value="item.cardByCard_amount | priceinput" @input="
                  (value) => {
                    item.cardByCard_amount =
                      value !== '' ? +value.replace(/\D/g, '') : '';
                  }
                " />
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">مبلغ پرداخت نقدی (تومان):</span>
                <b-form-input style="width: 130px" :value="item.cash_amount | priceinput" @input="(value) => {
                  item.cash_amount = value !== '' ? +value.replace(/\D/g, '') : 0;
                }" />
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">
                  میزان کسر از کیف پول (تومان):
                </span>
                <span class="px-3 py-2">
                  {{ item.from_wallet_amount | price }} تومان
                </span>
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">پرداخت نهایی (ریال):</span>
                <span class="px-3 py-2" :class="{
                  'text-success': totalPrice >= 0,
                  'text-danger': totalPrice < 0,
                }">
                  {{ (totalPrice * 10) | price }} ریال
                </span>
              </div>
            </div>
            <div class="mt-4 w-100 d-flex justify-content-center">
              <button type="submit" :class="{ reqDiasableStyle: !reqDiasableStyle }" class="btn btn-warning">
                ویرایش سفارش
              </button>
            </div>
          </template>
        </form>
      </div>
      <div id="selectSellerModal" @click="closeModal" v-if="showModal">
        <div id="selectSellerModalContainer">
          <div class="card">
            <div class="card-header border-0">
              <h5 class="card-title font-bold py-3">انتخاب فروشنده</h5>
              <div style="flex: 1"></div>
              <b-button variant="danger" @click="closeModal('close')">X</b-button>
            </div>
            <div class="card-body">
              <div id="selectSeller">
                <button v-for="(seller, index) in sellers" :key="index" class="sellerBtn" type="button"
                  @click="selectedSellerForVariety(seller)">
                  {{ seller.label }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BTable,
  BButton,
  BFormCheckbox,
  BFormTextarea,
} from "bootstrap-vue";
import PlusSvg from "@@/core/components/svgs/PlusSvg";
import DashSvg from "@@/core/components/svgs/DashSvg";
import Back from "@@/core/components/shared/Back/Back";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";

export default {
  name: "ShopEdit",
  components: {
    DashSvg,
    PlusSvg,
    BFormGroup,
    BFormInput,
    BTable,
    BFormCheckbox,
    BFormTextarea,
    BButton,
    Back,
    ProductSearch,
  },
  data() {
    return {
      editDiscount: {},
      disabled: false,
      refund: false,
      selectedSeller: null,
      selectedSellerId: null,
      showModal: false,
      created_at: null,
      discountAmount: 0,
      cardByCard_amount: null,
      id: this.$route.params.id,
      cash_amount: null,
      description: null,
      sendCoupenStatus: false,
      sellers: [],
      seller_ids: {},
      selectedVarietyId: null,
      productSku: "",
      reqDiasableStyle: true,
      fields: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "barcode",
          label: "بارکد",
        },
        {
          key: "title",
          label: "عنوان",
        },
        {
          key: "amount",
          label: "قیمت واحد (تومان)",
        },
        {
          key: "quantity",
          label: "تعداد",
        },
        {
          key: "discount_amount",
          label: "تخفیف واحد (تومان)",
        },
        {
          key: "seller_id",
          label: "فروشنده",
        },
        {
          key: "total_price",
          label: "قیمت نهایی (تومان)",
        },
        {
          key: "more",
          label: "حذف",
        },
      ],
      varieties: [],
      item: { mini_order_items: [] },
      admin: [],
      refund_varieties: [],
      disableCoupen: false,
      addedProduct: [],
    };
  },
  computed: {
    isDiscountFilled() {
      if (this.discountAmount > 0) {
        return true;
      } else if (this.totalPrice <= 0 && this.cardByCard_amount <= 0 && this.cash_amount <= 0) {
        return true;
      } else {
        return false;
      }
    },
    total() {
      if (!this.item || !this.item.mini_order_items) return 0;
      return this.sellItems.reduce((a, b) => {
        if (!b) return a;
        const price = b.price
          ? b.price
          : (b.real_amount && b.real_amount > 0)
            ? b.real_amount
            : b.amount ;
        return a + price * (b.quantity || 0);
      }, 0);
    },
    totalPrice() {
      if (!this.item || !this.item.mini_order_items) return 0;
      let totalAmount = this.total;
      if (this.item.from_wallet_amount) {
        totalAmount -= this.item.from_wallet_amount;
      }
      if (this.item.discount_amount > 0) {
        totalAmount -= this.item.discount_amount;
      }
      if (this.item.cardByCard_amount > 0) {
        totalAmount -= this.item.cardByCard_amount;
      }
      if (this.item.cash_amount > 0) {
        totalAmount -= this.item.cash_amount;
      }
      totalAmount = totalAmount - this.sellItems.reduce((a, b) => a + (b.final_price && b.final_price.discount_price > 0 ?
        b.final_price.discount_price * b.quantity : b.discount_amount * b.quantity), 0);
      const refundsAmount = this.refundItems.reduce((a, b) => a + (b.price
        ? b.price * b.quantity
        : b.variety.price * b.quantity),
        0) - this.refundItems.reduce((a, b) => a + (b.final_price ? b.final_price.discount_price
          : b.discount_amount * b.quantity), 0);
      totalAmount = totalAmount - refundsAmount;

      return totalAmount;
    },
    sellItems() {
      if (!this.item || !this.item.mini_order_items) return [];
      return this.item.mini_order_items.filter(item => item.type === 'sell');
    },
    refundItems() {
      if (!this.item || !this.item.mini_order_items) return [];
      return this.item.mini_order_items.filter(item => item.type === 'refund');
    }
  },
  created() {
    this.loadItem();
    this.getSellers();
    this.getAdmin();
  },
  methods: {
    async getAdmin() {
      const response = await this.$axios.get("admin/home");
      this.admin = response.data.data.admin;
    },
    async loadItem() {
      try {
        const response = await this.$axios.get("admin/mini_orders/" + this.id, {
          params: {
            widgets: JSON.stringify(["settings"]),
          },
        });
        this.miniOrder = response.data.data.mini_order;
        const miniOrder = response.data.data.mini_order;
        this.created_at = miniOrder.created_at;
        miniOrder.mini_order_items.forEach((miniOrderItem) => {
          miniOrderItem.extra = JSON.parse(miniOrderItem.extra);
        });
        const settings = {};
        response.data.data.widgets.settings.forEach((s) => {
          settings[s.name] = s.value;
        });
        this.settings = settings;
        this.item = miniOrder;
        this.item.mini_order_items.forEach(miniOrderItem => {
          if ((!miniOrderItem.real_amount || miniOrderItem.real_amount <= 0) && miniOrderItem.amount && (!miniOrderItem.discount_amount || miniOrderItem.discount_amount <= 0)) {
            miniOrderItem.real_amount = miniOrderItem.amount;
          }
        });

        console.log(this.item.mini_order_items);
        
      } catch (e) {
        this.$root.notify(e);
      }
    },
    async getSellers() {
      const response = await this.$axios.get("admin/sellers?all=1&is_active=1");
      this.sellers = response.data.data.sellers.map((s) => {
        s.label = `${s.full_name}`;
        return s;
      });
    },
    addVariety(variety) {
      const mode = this.refund ? "refund_varieties" : "varieties";
      const alreadyAdded = this.item.mini_order_items.find(
        (v) => (v.variety?.id ?? v.id) === variety.id
      );
      variety.type = this.refund ? 'refund' : 'sell';
      if (alreadyAdded && variety.type == alreadyAdded.type) {
        alreadyAdded.quantity++;
        
        this.$root.notify(
          "به تعداد محصول اضافه شد " + alreadyAdded.quantity,
          "success"
        );
      } else {
        variety.quantity = 1;
        if (variety.final_price && variety.final_price.amount && variety.final_price.discount_price < 1) {
          variety.real_amount = variety.final_price.amount;
          variety.amount = variety.final_price.amount;
          variety.discount_amount = 0;
        } else {
          variety.amount = variety.final_price.amount;
          variety.real_amount = variety.final_price.amount + variety.final_price.discount_price;
          variety.discount_amount = variety.final_price.discount_price;
        }
        this.item.mini_order_items.push(variety);
        this.$root.notify(
          " محصول اضافه شد ",
          "success"
        );
      }
      this.addedProduct = variety;
    },
    selectVariety(variety) {
      this.addVariety(variety);
    },
    async requestProduct() {
      try {
        this.disabled = true;
        const response = await this.$axios.get("admin/mini_orders/search", {
          params: {
            barcode: this.productSku,
            refund: this.refund,
          },
        });
        const variety = response.data.data.variety;
        this.addVariety(variety);
        this.productSku = "";
        if (this.coupenPrice) {
          this.coupenPrice = null;
          this.$root.notify(
            "جهت محاسبه کد تخفیف آنرا مجددا وارد کنید",
            "warning"
          );
        }
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.$nextTick(() => {
          this.$refs.productSku.focus();
        });
      }
    },
    selectedSellerForVariety(seller) {
      this.$set(this.seller_ids, this.selectedVarietyId, {
        label: seller.label,
        seller_id: seller.id,
        mini_order_item_id: this.selectedVarietyId,
      });
      this.closeModal("close");
    },
    sellerModalHandler(id) {
      this.selectedVarietyId = id;
      this.showModal = true;
    },
    deleteItem(index, item) {
      if (item.mini_order_id) {
        window
          .swal({
            title: "آیتم حذف شود؟",
            text: "این عملیات غیر قابل بازگشت خواهد بود",
            icon: "warning",
            showCancelButton: true,
            showConfirmButton: true,
            dangerMode: true,
            buttons: ["خیر", "بله حذف کن"],
          })
          .then((willDelete) => {
            if (willDelete) {
              this.$axios
                .delete('admin/mini-order-items' + `/${item.id}`)
                .then((response) => {
                  if (item.type === 'sell') {
                    this.sellItems.splice(index, 1);
                  } else if (item.type === 'refund') {
                    this.refundItems.splice(index, 1);
                  }

                  const mainIndex = this.item.mini_order_items.findIndex(
                    mainItem => mainItem.id === item.id
                  );
                  if (mainIndex !== -1) {
                    this.item.mini_order_items.splice(mainIndex, 1);
                  }
                  window.swal({
                    icon: "success",
                    showConfirmButton: true,
                    text: response.data.message,
                    button: "باشه",
                  });
                })
                .catch((error) => {
                  window.swal({
                    title: "���",
                    showConfirmButton: true,
                    text: error.response.data.message,
                    button: "باشه",
                  });
                });
            }
          })
          .catch(() => { });
      } else {
        if (item.type === 'sell') {
          this.sellItems.splice(index, 1);
        } else if (item.type === 'refund') {
          this.refundItems.splice(index, 1);
        }

        const mainIndex = this.item.mini_order_items.findIndex(
          mainItem => mainItem.id === item.id
        );
        if (mainIndex !== -1) {
          this.item.mini_order_items.splice(mainIndex, 1);
        }
      }
    },
    closeModal(e) {
      if (e == "close" || e.target.id == "selectSellerModal") {
        this.showModal = false;
      }
    },
    decrement(variety) {
      if (variety.quantity === 0) {
        return;
      }
      variety.quantity--;
      if (variety.amount) {
        variety.amount = variety.amount - variety.product.unit_price;
      } else {
        variety.final_price.amount = variety.final_price.amount - variety.product.unit_price;
      }
    },
    increment(variety) {
      variety.quantity++;
      if (variety.amount) {
        variety.amount = variety.amount + variety.product.unit_price;
      } else {
        variety.final_price.amount = variety.final_price.amount + variety.product.unit_price;
      }
    },
    getAmount(item) {
      if (item.price) {
        return item.price;
      } else if (item.real_amount > 0) {
        return item.real_amount;
      } else {
        return item.amount || "N/A";
      }
    },
    async submit() {
      const createdAtWithoutSeconds = this.created_at.substring(0, 16);
      const items = [];
      this.item.mini_order_items.forEach(miniOrderItem => {
        const seller = this.seller_ids[miniOrderItem.id];
        miniOrderItem.seller_id = seller ? seller.seller_id : miniOrderItem.seller_id;
        const miniOrderItemId = miniOrderItem.mini_order_id ? miniOrderItem.id : '';
        let discount_amount = 0;
        if (!miniOrderItem.discount_amount) {
          discount_amount = 0;
        } else {
          discount_amount = miniOrderItem.final_price && miniOrderItem.final_price.discount_price > 0
            ? miniOrderItem.final_price.discount_price : miniOrderItem.discount_amount;
        }
        const item = {
          mini_order_item_id: miniOrderItemId,
          seller_id: miniOrderItem.seller_id,
          quantity: miniOrderItem.quantity,
          type: miniOrderItem.type,
          discount_amount: discount_amount,
          real_amount:  miniOrderItem.real_amount,
          amount: (miniOrderItem.real_amount && miniOrderItem.real_amount > 0 ? miniOrderItem.real_amount : miniOrderItem.amount) -
            (miniOrderItem.final_price && miniOrderItem.final_price.discount_price > 0 ?
              miniOrderItem.final_price.discount_price : miniOrderItem.discount_amount),
          variety_id: miniOrderItem.mini_order_id ? miniOrderItem.variety_id : miniOrderItem.id,
          mini_order_id: this.item.mini_order_items[0].mini_order_id,
        };
        items.push(item);
      });
      const data = {
        created_at: createdAtWithoutSeconds,
        cardByCard_amount: this.item.cardByCard_amount ?? 0,
        cash_amount: this.item.cash_amount ?? 0,
        discount_amount: this.item.discount_amount ?? 0,
        is_open: this.item.is_open,
        store_id: this.admin.store_id,
        items: items,
      };

      try {
        this.reqDiasableStyle = false;
        this.disabled = true;
        const response = await this.$axios.put(`admin/mini-orders/${this.id}/update`, data);
        const miniOrder = response.data.data.mini_order;

        this.$root.notify(response.data.message, "success");
        this.$router.push(`/admin/shop/`);
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.reqDiasableStyle = true;
      }
    },
  },
};
</script>

<style scoped>
  .table-responsive {
    height: auto;
  }

  .reqDiasableStyle {
    pointer-events: none;
    opacity: 0.5;
  }

  .order-product-img {
    max-width: 50px;
    margin: auto;
  }

  .table-title {
    font-weight: bold;
  }
</style>
<style>
  .card.little.info {
    background: linear-gradient(30deg, #d2e8ff 0%, #d5e6fc 35%, #eaf5ff 100%);
  }

  .card.little.online {
    background: linear-gradient(30deg, #c8ffc8 0%, #c8ffc8 35%, #e0ffe0 100%);
  }

  .card.little.physical {
    background: linear-gradient(30deg, #ffffe3 0%, #ffffbc 35%, #ffffc5 100%);
  }

  .card.little .card-header {
    font-weight: bold;
  }

  form#coupenCode input[type="submit"] {
    background-color: #1d99ff;
    color: white;
  }

  form#coupenCode input {
    padding: 4px 8px;
    border: 2px solid #1d99ff;
  }

  .disableCoupen {
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
  }

  button#sendCoupen {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  button#sendCoupen input {
    transform: scale(1.5);
  }

  .btnprimary {
    color: #fff !important;
    background-color: #0075ff;
    border-color: #3366ff;
  }

  .btnprimary:hover {
    background-color: #0256b8;
  }

  .btnprimary:hover input[type="checkbox"] {
    accent-color: #0256b8;
  }

  div#selectSeller button:hover,
  div#selectSeller button.active {
    transition: all 0.4s;
    background: #009eff;
    color: white;
  }

  div#selectSeller button {
    border: 1px solid grey;
    background: transparent;
    box-shadow: 0 0 4px #1122115e;
    padding: 4px;
    border-radius: 6px;
  }

  div#selectSeller {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
  }

  div#selectSeller button:hover,
  div#selectSeller button.active {
    transition: all 0.4s;
    background: #009eff;
    color: white;
  }

  div#selectSeller button {
    border: 1px solid grey;
    background: transparent;
    box-shadow: 0 0 4px #1122115e;
    padding: 4px;
    border-radius: 6px;
  }

  div#selectSeller {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
  }

  .mt-3.admin-order.table-responsive.id.price.barcode.product_id.order.max_number_purchases.created_at.updated_at.unique_attributes_key.images.user_images.quantity.final_price.attributes.product.store.id.price.barcode.product_id.order.max_number_purchases.created_at.updated_at.unique_attributes_key.images.user_images.quantity.final_price.attributes.product.store {
    overflow: visible;
  }

  div#selectSellerModal {
    position: fixed;
    inset: 0;
    background: #11221194;
    z-index: 10000;
  }

  div#selectSellerModalContainer {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    top: 50%;
  }
</style>